<template>
    <CommonDialog v-show="show" :title="title" class="confirm-dialog" @close="handleClose">
        <template v-slot:msg>
            <span class="dialog-message">{{ message }}</span>
        </template>
        <template v-slot:buttons>
            <div class="button-slot button-group">
                <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(cancelBtnColor)" @click="handleCancel">{{ cancelTxt }}</div>
                <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(confirmBtnColor)" @click="handleConfirm">{{ confirmTxt }}</div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
import { buttonBackgroundColor } from '../../js/dialog/dialog_button';
export default {
    name: "ConfirmDialog",
    data: function () {
        return {
            show: false,
            title: "",
            message: "確定要刪除嗎？",
            confirmTxt: "確定",
            cancelTxt: "取消",
            confirmCallback: null,
            cancelCallback: null,
            confirmBtnColor: "orange",
            cancelBtnColor: "blue",
            buttonBackgroundColor
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        /**
         * 設定對話框並開啟
         * @param {string} title 
         * @param {string} message 
         * @param {function} confirmCallback 
         * @param {function} cancelCallback 
         * @param {string} confirmTxt 
         * @param {string} cancelTxt 
         */
        showDialog(title, message, confirmCallback, cancelCallback, confirmTxt = "確定", cancelTxt = "取消", confirmColor = "orange", cancelColor = "blue") {
            this.title = title;
            this.message = message;
            this.confirmTxt = confirmTxt;
            this.cancelTxt = cancelTxt;
            this.confirmCallback = confirmCallback;
            this.cancelCallback = cancelCallback;
            this.confirmBtnColor = confirmColor;
            this.cancelBtnColor = cancelColor;
            this.show = true;
        },
        /**
         * 執行confirm callback
         */
        handleConfirm() {
            if (typeof this.confirmCallback == "function") {
                this.confirmCallback();
            }
            this.show = false;
        },
        handleCancel() {
            console.log("cancel click");
            if (typeof this.cancelCallback == "function") {
                this.cancelCallback();
            }
            this.show = false;
        },
        handleClose() {
            this.show = false;
        }
    }
}
</script>
<style src="../../css/dialog_style.css">

</style>
<style lang="css" scoped>
.button-slot {
    margin-bottom: 1rem;
}
</style>